import moment from "moment";

export const TABLE_COLUMN_KEYS = {
  CODE: "code",
  FULL_NAME: "fullName",
  REQUEST_TYPE: "requestType",
  TOTAL_DAYS: "totalDays",
  PROCESSED_BY: "processedBy",
  START_DATE: "startDate",
  END_DATE: "endDate",
  STATUS: "status",
};

export const TABLE_COLUMN_HEADERS = {
  [TABLE_COLUMN_KEYS.CODE]: "Código",
  [TABLE_COLUMN_KEYS.FULL_NAME]: "Nombre",
  [TABLE_COLUMN_KEYS.REQUEST_TYPE]: "Tipo de solicitud",
  [TABLE_COLUMN_KEYS.START_DATE]: "Fecha inicio",
  [TABLE_COLUMN_KEYS.END_DATE]: "Fecha fin",
  [TABLE_COLUMN_KEYS.TOTAL_DAYS]: "Días",
  [TABLE_COLUMN_KEYS.PROCESSED_BY]: "Responsable",
  [TABLE_COLUMN_KEYS.STATUS]: "Estado",
} as const;

export const EXPORT_COLUMN_KEYS = TABLE_COLUMN_KEYS;

export const EXPORT_COLUMN_HEADERS = TABLE_COLUMN_HEADERS;

export const VACATION_REQUESTS_COLUMNS = [
  {
    field: TABLE_COLUMN_KEYS.CODE,
    header: TABLE_COLUMN_HEADERS[TABLE_COLUMN_KEYS.CODE],
    sortable: true,
    align: "left",
    style: { width: "5.625rem", minWidth: "5.625rem" },
    frozen: true,
  },
  {
    field: TABLE_COLUMN_KEYS.FULL_NAME,
    header: TABLE_COLUMN_HEADERS[TABLE_COLUMN_KEYS.FULL_NAME],
    sortable: true,
    align: "left",
    style: { width: "12.5rem", minWidth: "12.5rem", flex: 1 },
    frozen: true,
  },
  {
    field: TABLE_COLUMN_KEYS.REQUEST_TYPE,
    header: TABLE_COLUMN_HEADERS[TABLE_COLUMN_KEYS.REQUEST_TYPE],
    sortable: true,
    align: "left",
    style: { minWidth: "10rem", flex: 1 },
  },
  {
    field: TABLE_COLUMN_KEYS.START_DATE,
    header: TABLE_COLUMN_HEADERS[TABLE_COLUMN_KEYS.START_DATE],
    sortable: true,
    align: "left",
    style: { minWidth: "10rem" },
    body: (value) => moment.utc(value.startDate).format("DD/MM/YYYY"),
  },
  {
    field: TABLE_COLUMN_KEYS.END_DATE,
    header: TABLE_COLUMN_HEADERS[TABLE_COLUMN_KEYS.END_DATE],
    sortable: true,
    align: "left",
    style: { minWidth: "10rem" },
    body: (value) => moment.utc(value.endDate).format("DD/MM/YYYY"),
  },
  {
    field: TABLE_COLUMN_KEYS.TOTAL_DAYS,
    header: TABLE_COLUMN_HEADERS[TABLE_COLUMN_KEYS.TOTAL_DAYS],
    sortable: true,
    align: "left",
    style: { minWidth: "5rem" },
  },
  {
    field: TABLE_COLUMN_KEYS.STATUS,
    header: TABLE_COLUMN_HEADERS[TABLE_COLUMN_KEYS.STATUS],
    sortable: true,
    align: "center",
    style: { minWidth: "10rem" },
  },
  {
    field: TABLE_COLUMN_KEYS.PROCESSED_BY,
    header: TABLE_COLUMN_HEADERS[TABLE_COLUMN_KEYS.PROCESSED_BY],
    sortable: true,
    align: "left",
    style: { minWidth: "11.25rem", flex: 1 },
  },
];
